import Rest from '../rest'

/******************************************************************************
 * Active Offer
 *****************************************************************************/

/**
 * @type {ActiveOffer}
 */
export default class ActiveOffer extends Rest {

    constructor () {
        super('/facqueues/processor')
    }

    /**
     * Busca as filas de leads ativas de um usuário
     * 
     * @param {String|Integer} userId ID do usuário
     * @returns 
     */
    getUserQueues(userId) {
        return super.get('element', this.constructor.normalize(userId, '/queues/offers'))
            .then(response => {
                const data = Object.values(response.data)
                    .filter(queue => {
                        return queue.status === 'active'
                    })
                    .map(queue => {
                        return { label: queue.name, value: queue.id }
                    })
                response.data = [...data]

                return response
            })
    }

    /**
     * Busca os dados de uma fila de Leads ativa para processamento
     * 
     * @param {String|Integer} queueId ID da fila de Leads ativa
     * @returns 
     */
    getOffer(queueId) {
        return super.create(this.constructor.normalize(this.constructor.normalize('queue', queueId), 'process'))
    }

    /**
     * Busca 
     * @param {String|Integer} queueId ID da fila de Leads ativa
     * @returns 
     */
    getQueueReasons(queueId) {
        return super.get('queue', this.constructor.normalize(queueId, 'reasons'))
        .then(response => {
            const data = Object.values(response.data)
                .map(reason => {
                    return { label: reason.description, value: reason.id }
                })
            if (data.length) {
                response.data = [...data]

            } else {
                response.data = [{
                    label: 'Não há respostas cadastradas nessa fila!',
                    value: null
                }]
            }

            return response
        })
    }

    /**
     * Salva as configurações de processamento em uma fila de Leads ativa
     * 
     * @param {String|Integer} queueId ID da fila de Leads ativa
     * @returns 
     */
    saveOffer(queueId, data) {
        return super.create(
            this.constructor.normalize(
                this.constructor.normalize('queue', queueId),
                'save'
            ),
            data
        )
    }

    /**
     * Busca todas as filas de Oferta Ativa, independentemente se elas estão ou não vinculadas
     * ao usuário logado
     *
     * @returns JSON|Array
     */
    getAllQueues() {
        return this.http.get('facqueues/main')
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }
}